module.exports = __webpack_public_path__ + "img/Icon_AddMemberBtn.7c8cb041.png";